<div class="row">
  <div class="col-md-6">
    <mat-card class="graph-section">
      <mat-card-header>
        <h4 class="heading">My Contracts: Status wise</h4>
      </mat-card-header>
      <mat-card-content class="pieCHart1" id="pie2">
      </mat-card-content>
    </mat-card>
  </div>
  <div class="col-md-6">
    <mat-card class="graph-section">
      <mat-card-header>
        <h4 class="heading">My Contracts: By Type Of Paper</h4>
      </mat-card-header>
      <mat-card-content class="pieCHart1" id="pie">
      </mat-card-content>
    </mat-card>

  </div>
</div>